module.exports = __webpack_public_path__ + "static/media/logout.a3a67e58.svg";